import { styled, css } from 'styled-components'
import { motion } from 'framer-motion'
import { COLORS } from 'consts/colors'
import { TOOLTIP_Z_INDEX } from 'consts/zIndex'

import { TOP, BOTTOM, LEFT, RIGHT } from './consts'
import { ITooltipProps } from './types'
import { TPosition } from 'types'

const BORDER_STYLE = `7px solid ${COLORS.secondaryExtraDark};`
const TRANSPARENT_BORDER_STYLE = '7px solid transparent'

const getTooltipTriangleStyles = ({ position }: { position: TPosition }) => {
  switch (position) {
    case TOP:
      return css`
        bottom: 0;
        left: 50%;
        transform: translate(-50%, 100%);
        border-left: ${TRANSPARENT_BORDER_STYLE};
        border-right: ${TRANSPARENT_BORDER_STYLE};
        border-top: ${BORDER_STYLE};
      `
    case BOTTOM:
      return css`
        top: 0;
        left: 50%;
        transform: translate(-50%, -100%);
        border-left: ${TRANSPARENT_BORDER_STYLE};
        border-right: ${TRANSPARENT_BORDER_STYLE};
        border-bottom: ${BORDER_STYLE};
      `
    case LEFT:
      return css`
        right: 0;
        top: 50%;
        transform: translate(100%, -50%);
        border-top: ${TRANSPARENT_BORDER_STYLE};
        border-bottom: ${TRANSPARENT_BORDER_STYLE};
        border-left: ${BORDER_STYLE};
      `
    case RIGHT:
      return css`
        left: 0;
        top: 50%;
        transform: translate(-100%, -50%);
        border-top: ${TRANSPARENT_BORDER_STYLE};
        border-bottom: ${TRANSPARENT_BORDER_STYLE};
        border-right: ${BORDER_STYLE};
      `
    default:
      return ''
  }
}
export const Tooltip = styled(motion.div)<ITooltipProps>`
  max-width: 250px;
  position: fixed;
  z-index: ${TOOLTIP_Z_INDEX};
  color: ${COLORS.white};
  font-size: 12px;
  border-radius: 8px;
  padding: 8px;
  background-color: ${COLORS.secondaryExtraDark};
  box-sizing: border-box;
  line-height: 20px;
  overflow-wrap: break-word;
  text-align: center;

  ${({ coords: { x, y } }) => css`
    left: ${x}px;
    top: ${y}px;
  `}

  .triangle {
    position: absolute;
    width: 0;
    height: 0;
    border-style: solid;
    ${getTooltipTriangleStyles}
  }
`
